module.exports = __webpack_public_path__ + "static/media/ie.c68ff961.svg";